import React from 'react';
import PropTypes from 'prop-types';

const TextArea = (props) => (<textarea
  style={props.styleVal}
  className={props.classVal}
  placeholder={props.placeHolder}
  rows={props.rows}
  onChange={(ev) => props.onChangeHandler(ev)}
/>);

TextArea.propTypes = {
  styleVal: PropTypes.object,
  classVal: PropTypes.string,
  placeHolder: PropTypes.string,
  rows: PropTypes.number,
  onChangeHandler: PropTypes.func.isRequired
};
export default TextArea;
